import { isIOS } from "react-device-detect";

import phoneMockup from "../assets/Iphone17.png";
import starIcon from "../assets/Group 203.svg";
import AppStoreBadge from "../assets/App Store.svg";
import GooglePlayBadge from "../assets/Google Play.svg";

import img1 from "../assets/Image1.png";
import img2 from "../assets/Image2.png";
import img3 from "../assets/Image3.png";
import img4 from "../assets/Image4.png";
import img5 from "../assets/Image5.png";

const images = [img1, img2, img3, img4, img5];

const Hero = () => {
  const appStoreUrl = "https://apps.apple.com/gb/app/luupli/id6463861554";
  const playStoreUrl =
    "https://play.google.com/store/apps/details?id=com.dev.luupli.uat&hl=en_GB";

  /* [1,2,3,4,5,1,2,3,4,5] - when strip moves right (-50%), last card exits right, first reappears from left */
  const loopImages = [...images, ...images];

  return (
    <section id="top" className="relative overflow-hidden bg-white">
      <div className="max-w-[1520px] mx-auto px-4 md:px-6 lg:px-8 pt-10 md:pt-12 lg:pt-14 pb-10 md:pb-14">
        <div className="flex flex-col lg:grid lg:grid-cols-[minmax(0,400px)_minmax(0,1fr)] xl:grid-cols-[minmax(0,520px)_minmax(0,1fr)] 2xl:grid-cols-[721px_minmax(520px,1fr)] items-center lg:items-start gap-6 xl:gap-8 2xl:gap-10">

          {/* LEFT TEXT */}
          <div className="w-full max-w-[721px] flex flex-col items-center lg:items-start text-center lg:text-left pt-2 lg:pt-4">

            <div className="mb-5 lg:mb-6 self-start">
              <img
                src={starIcon}
                alt=""
                aria-hidden="true"
                className="w-[56px] lg:w-[64px] xl:w-[72px] 2xl:w-[84px]"
              />
            </div>

            <h1 className="font-serif text-[52px] leading-[62px] md:text-[72px] md:leading-[94px] lg:text-[52px] lg:leading-[64px] xl:text-[72px] xl:leading-[90px] 2xl:text-[100px] 2xl:leading-[125px] font-medium tracking-[-0.02em] text-black">
              Create together.
              <br />
              Get discovered.
              <br />
              Get paid locally.
            </h1>

            <div className="flex items-center justify-center lg:justify-start flex-wrap gap-[14px] mt-12 lg:mt-8 xl:mt-10 2xl:mt-14">

              <a
                href={appStoreUrl}
                target="_blank"
                rel="noreferrer"
                className={`${isIOS ? "block" : "hidden"} lg:block`}
              >
                <img
                  src={AppStoreBadge}
                  alt="Download on the App Store"
                  className="h-12 lg:h-[48px] xl:h-[52px] 2xl:h-[61px]"
                />
              </a>

              <a
                href={playStoreUrl}
                target="_blank"
                rel="noreferrer"
                className={`${isIOS ? "hidden" : "block"} lg:block`}
              >
                <img
                  src={GooglePlayBadge}
                  alt="Get it on Google Play"
                  className="h-12 lg:h-[48px] xl:h-[52px] 2xl:h-[61px]"
                />
              </a>

            </div>
          </div>

          {/* PHONE MOCKUP */}
          <div className="w-full flex justify-center lg:justify-end relative">

            <img
              src={phoneMockup}
              alt="Luupli app preview"
              className="w-full max-w-[500px] lg:max-w-[340px] xl:max-w-[400px] 2xl:max-w-[500px]"
            />

            {/* CARD STRIP */}
            <div
              className="absolute z-30 bottom-[18%] left-[-14%] w-[128%] lg:left-[30%] lg:w-[80%] overflow-hidden"
              style={{
                maskImage:
                  "linear-gradient(to right, transparent, black 8%, black 85%, transparent)",
                WebkitMaskImage:
                  "linear-gradient(to right, transparent, black 8%, black 85%, transparent)",
              }}
            >

              <div className="flex flex-nowrap gap-3 w-max animate-hero-bounce">
                {loopImages.map((src, i) => (
                  <img
                    key={i}
                    src={src}
                    alt=""
                    aria-hidden="true"
                    className="w-[90px] h-[112px] rounded-xl object-cover shrink-0 shadow-[0_4px_12px_rgba(0,0,0,0.06)]"
                  />
                ))}

              </div>

            </div>

          </div>

        </div>
      </div>
    </section>
  );
};

export default Hero;